import Tabs from '@/components/tabs/Tabs';
import TabsContainer from '@/components/tabs/TabsContainer';

interface IssueTabsProps {
  panels: string[];
  routes: string[];
  onChange: (newValue: string) => void;
}

const IssueTabs = ({ panels, routes, onChange }: IssueTabsProps) => (
  <TabsContainer>
    <Tabs panels={panels} routes={routes} onChange={onChange} />
  </TabsContainer>
);

export default IssueTabs;
